/**
 * Plush: fix product-gallery slider arrows with variant-filtered media.
 *
 * Dawn computes the prev/next arrow state once (and recomputes only via a
 * ResizeObserver on the slider itself). When a variant hides/shows thumbnails,
 * the slider's own size doesn't change, so Dawn never recomputes — leaving the
 * "next" arrow wrongly disabled even though the visible thumbnails overflow.
 *
 * This re-runs Dawn's own initPages() on the gallery sliders after load and on
 * resize, so the arrows reflect the actually-visible images.
 *
 * Variant changes are NOT handled here. plush-variant-media.js refreshes the
 * sliders itself, immediately after it changes which photos are visible. This
 * file used to watch the thumbnail list for [hidden] changes as well - the very
 * attribute that file writes - so a single colour change re-measured both
 * sliders over and over. Measured 30-10-2026: initPages() ran 15 times per
 * colour change, each reading clientWidth for 16 slides on 2 sliders.
 */
(function () {
  'use strict';

  function refresh() {
    document
      .querySelectorAll('slider-component[id*="Gallery"], slider-component.thumbnail-slider')
      .forEach(function (sc) {
        if (typeof sc.initPages === 'function') sc.initPages();
      });
  }

  function boot() {
    // Two passes: one once the markup is up, one after the images have had a
    // chance to load and settle their widths. A third pass measured the same
    // numbers again for nothing.
    [150, 1200].forEach(function (t) {
      window.setTimeout(refresh, t);
    });
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__plushThumbResizeTimer);
    window.__plushThumbResizeTimer = window.setTimeout(refresh, 150);
  });
})();
